import { render, staticRenderFns } from "./FlorestasPublicas.vue?vue&type=template&id=a87d873a&lang=pug"
import script from "./FlorestasPublicas.vue?vue&type=script&lang=js"
export * from "./FlorestasPublicas.vue?vue&type=script&lang=js"
import style0 from "./FlorestasPublicas.vue?vue&type=style&index=0&id=a87d873a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports